import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import "./NationalEssayPrizesPage.scss";

type EssayPrizePageLayoutProps = {
  heroLabel: string;
  heroTitle: ReactNode;
  heroLead: ReactNode;
  children: ReactNode;
  /** Tighter spacing below main content (overview page). */
  compactFooterSpacing?: boolean;
};

const EssayPrizePageLayout = ({
  heroLabel,
  heroTitle,
  heroLead,
  children,
  compactFooterSpacing = false,
}: EssayPrizePageLayoutProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <NavBar />
      <div id="NationalEssayPrizesPage">
        <header className="tml-hero nep-hero" aria-label={typeof heroTitle === "string" ? heroTitle : heroLabel}>
          <div className="site-container">
            <p className="tml-eyebrow">{heroLabel}</p>
            <h1 className="tml-hero__title">{heroTitle}</h1>
            <p className="tml-hero__lead">{heroLead}</p>
          </div>
        </header>

        <main
          className={`tml-main nep-main${compactFooterSpacing ? " nep-main--overview" : ""}`}
        >
          <div className="site-container">{children}</div>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default EssayPrizePageLayout;
